import SumsubWebSdk from "@sumsub/websdk-react";
import * as React from "react";
import { useParams } from "react-router-dom";
import { AvererContainer } from "./AvererContainer";
import "./LandingPage.css";
import { NotFoundScreen } from "./NotFoundScreen";
import { UUID_REGEX } from "./constants";

export const Sumsub = () => {
  const [isValidEntityId, setValidEntityId] = React.useState(true);
  const [accessToken, setAccessToken] = React.useState("");
  const { entityId } = useParams();
  const [loader, setLoader] = React.useState(true);

  const messageHandler = React.useCallback(
    (event) => {
      if (entityId.match(UUID_REGEX)) {
        setValidEntityId(true);
        if (!accessToken) {
          setAccessToken(event.data.token);
          setLoader(false);
        }
      } else {
        setValidEntityId(false);
      }
    },
    [accessToken, entityId]
  );

  React.useEffect(() => {
    window.addEventListener("message", messageHandler, false);
    return () => {
      window.removeEventListener("message", messageHandler, false);
    };
  }, [messageHandler]);

  const accessTokenExpirationHandler = React.useCallback(() => {
    return new Promise((resolve, reject) => {
      try {
        resolve(accessToken);
      } catch (error) {
        reject(error);
      }
    });
  }, [accessToken]);

  return isValidEntityId ? (
    <AvererContainer>
      {loader && (
        <div className="animated-loader">
          <div className='loader' />
        </div>
      )}
      {accessToken && !loader && (
        <SumsubWebSdk
          accessToken={accessToken}
          expirationHandler={accessTokenExpirationHandler}
          onMessage={(type, payload) => {
          if (type === "idCheck.onResize" && payload?.height) {
            window.parent.postMessage(
              { source: "sumsub", type: "resize", height: payload.height },
              "*"
            );
          }
        }}
        />
      )}
    </AvererContainer>
  ) : (
    <NotFoundScreen />
  );
};
